import { Consts } from 'models/consts';
import React, { useEffect, useState } from 'react';
import { getItem, setItem } from 'utils/localStorageHelper';

interface ConfigContextType extends Consts {
  cloudUrl: string;
  cloudApiUrl: string;
  cbtApiUrl: string;
  developmentRttyUrl: string;
  defaultUserEmail: string;
  getDefaultConfig: () => void;
}

interface ConfigProviderType {
  children: React.ReactNode;
}

const ConfigContext = React.createContext<ConfigContextType>(null!);

export const ConfigProvider = ({ children }: ConfigProviderType) => {
  const storagDefaultConfig = getItem('defaultConfig') ?? '{}';
  const [defaultConfig, setDefaultConfig] = useState<ConfigContextType>(JSON.parse(storagDefaultConfig));

  const getDefaultConfig = async () => {
    fetch(`${process.env.PUBLIC_URL}/config.json`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response: Response) => response.json())
      .then((json: ConfigContextType) => {
        fetch(`${json.cbtApiUrl}api/utils/consts`, { headers: { 'X-siteId': getItem('siteId') ?? '' } })
          .then((response: Response) => response.json())
          .then((data: Consts) => {
            if (json.cloudApiUrl === undefined) {
              if (json.cloudUrl.includes(':3002')) {
                //development mode
                json.cloudApiUrl = `http://${json.cloudUrl}`;
              } else {
                //production mode
                json.cloudApiUrl = `https://${json.cloudUrl}`;
              }
            }
            setDefaultConfig(Object.assign(json, data));
            setItem('defaultConfig', JSON.stringify(Object.assign(json, data)));
          });
      })
      .catch((error) => {
        const err = error as { response?: { data: { message?: string } } };
        console.error(err?.response?.data.message);
      });
  };

  useEffect(() => {
    getDefaultConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ConfigContext.Provider value={{ ...defaultConfig, getDefaultConfig }}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => React.useContext(ConfigContext);
